// import { ReactComponent as Download } from '@Icons/additional/download.svg';
import { ReactComponent as DeleteIcon } from '@Icons/additional/trash.svg';
import { MButton } from '@Components/Base';

import styles from './column-header.module.css';
import { ViewTab } from '../../../ViewTab.enum';

interface ColumnHeaderProps {
  isAllSelected: boolean;
  count: number;
  activeTab: keyof typeof ViewTab;
  onDownload?: () => void;
  onDelete?: () => void;
}

const ColumnHeader: React.FC<ColumnHeaderProps> = ({
  activeTab,
  isAllSelected,
  count,
  // onDownload,
  onDelete,
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        {isAllSelected && 'All'}
        <span className={styles.textBold}>
          {count} {activeTab}
        </span>
        ON THIS PAGE ARE SELECTED
      </div>
      <div className={styles.actions}>
        {/* TODO: No functionallity, hide */}
        {/* <MButton
          type="text"
          icon={<Download />}
          className={styles.action}
          onClick={onDownload}
        >
          Download
        </MButton>
        <div className={styles.divider} /> */}
        <MButton
          type="text"
          icon={<DeleteIcon />}
          className={styles.action}
          onClick={onDelete}
        >
          Delete
        </MButton>
      </div>
    </div>
  );
};

export default ColumnHeader;
